import { createApi } from "@reduxjs/toolkit/query/react";
import { buildBaseQuery } from "@app/api";
import { FilterParams } from "types";

import { IProduct, ProductCreationPayload } from "../types/index";

export const productApi = createApi({
  reducerPath: "productApi",
  baseQuery: buildBaseQuery(""),
  endpoints: (builder) => ({
    getProducts: builder.query<{ products: IProduct[]; count: number}, Partial<FilterParams>>({
      query: (params) => {
        const queryString = Object.entries(params)
          .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
          .join('&');

        return `/products/dashboard?${queryString}`;
      },
    }),
    getProductById: builder.query<IProduct, string>({
      query: (productId) => `/products/${productId}`,
    }),
    createProduct: builder.mutation<void, ProductCreationPayload>({
      query: (body) => ({
        url: "/products",
        method: "POST",
        body,
      }),
    }),
    updateProduct: builder.mutation<void, {id: string; body: ProductCreationPayload}>({
      query: ({ id, body }) => ({
        url: `/products/${id}`,
        method: "PATCH",
        body,
      }),
    }),
    updateProductConfiguration: builder.mutation<void, {
      id: string;
      body: {
        bestSeller?: boolean;
        activeInHome?: boolean;
      };
    }>({
      query: ({ id, body }) => ({
        url: `/products/${id}/config`,
        method: "PATCH",
        body,
      }),
    }),
    updateProductOrdering: builder.mutation<void, { ids: string[] }>({
      query: (body) => ({
        url: `/products/update-ordering`,
        method: "PATCH",
        body,
      }),
    }),
    deleteProduct: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/products/${id}`,
        method: "DELETE",
      }),
    }),
  }),
});

export const {
  useGetProductsQuery,
  useLazyGetProductsQuery,
  useDeleteProductMutation,
  useCreateProductMutation,
  useUpdateProductMutation,
  useUpdateProductConfigurationMutation,
  useLazyGetProductByIdQuery,
  useUpdateProductOrderingMutation,
} = productApi;
